import * as mutationTypes from '../../../types/mutationTypes';
import * as getterTypes from '../../../types/getterTypes';
// import { logger } from '../../../tools';

export default {
	state: {
		// active: false,
		// current: null,
		// quizMap: {},
		dmxArticles: {},
	},
	getters: {
		[getterTypes.dmxArticles](state) {
			return state.dmxArticles;
		},
	},
	mutations: {
		/**
		 * store object of articles with dmx locations, and their dmx information
		 * @param {*} state
		 * @param { articlesObject } all articles with dmx location and their information
		 */
		[mutationTypes.dmxArticles](state, articlesObject) {
			state.dmxArticles = articlesObject;
		},
	},
	plugins: [
		(store) => {
			/**
			 * Plugin collects all tours that are quizzes
			 */
			store.subscribe((mutation, state) => {
				// on initialization of tours. collect tours that are quizzes
				if (mutation.type === mutationTypes.setDatasource) {
					const locations = Object.values(state.dataSourceCFG.locations).reduce((acc, location) => {
						if (location.type == 'dmxLocation') {
							for (let i = 0; i < location.articles.length; i++) {
								const curValues = acc[location.articles[i].article.id]
									? acc[location.articles[i].article.id]
									: [];
								acc[location.articles[i].article.id] = [...curValues, location.dmxLocation];
							}
						}
						return acc;
					}, {});

					store.commit(mutationTypes.dmxArticles, locations);
				} else if (mutation.type === mutationTypes.setArticleID) {
					const lastArticle = state.route.from ? state.route.from.params.articleID : null;
					const curArticle = state.currentArticleID;

					if (lastArticle && state.dmx.dmxArticles[lastArticle]) {
						const lights = state.dmx.dmxArticles[lastArticle];
						for (let i = 0; i < lights.length; i++) {
							fetch('http://10.0.0.1:10042/snowball-dmx.php', {
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded',
								},
								method: 'POST',
								mode: 'no-cors',
								body:
									'pad=' + lights[i].channel + '&op=pop&webClientID=' + store.state.persistent.webClientID,
							}).then(() => {});
						}
					}

					if (state.dmx.dmxArticles[curArticle]) {
						const lights = state.dmx.dmxArticles[curArticle];
						for (let i = 0; i < lights.length; i++) {
							fetch('http://10.0.0.1:10042/snowball-dmx.php', {
								headers: {
									'Content-Type': 'application/x-www-form-urlencoded',
								},
								method: 'POST',
								mode: 'no-cors',
								body:
									'pad=' + lights[i].channel + '&op=push&webClientID=' + store.state.persistent.webClientID,
							}).then(() => {});
						}
					}
				}
			});
		},
	],
	actions: {
		/**
		 * This action activates the quiz
		 * @param {*} state
		 * @param { quizID } quizID of quiz which to open
		 */
		// [actionTypes.quizStart]({ state, commit }, { quizID }) {
		//	logger.log(
		//		`QUIZ: Start Quiz for èxhibition: ${state.quizMap[quizID].exhibitionID} quiz ${quizID}`
		//	);
		//	commit(mutationTypes.quizStart, { quizId });
		// },
	},
};
